import { useMutation } from '@apollo/react-hooks';
import {
  DeleteEnseigne,
  DeleteEnseigneVariables,
} from '../../graphql/enseigne/types/DeleteEnseigne';
import { DELETE_ENSEIGNE } from '../../graphql/enseigne/mutation';

export const useDeleteEnseigne = () => {
  return useMutation<DeleteEnseigne, DeleteEnseigneVariables>(DELETE_ENSEIGNE, {
    onError: (error) => console.log('delete enseigne error ', error),
  });
};
